<template>
  <div
    :class="theme == 2 ? 'black' : 'bgffffff'"
    style="height: 100%; width: 100%; position: absolute"
  >
    <van-tabs
      v-model="active"
      title-active-color="#FA3B32"
      :title-inactive-color="theme == 2 ? '#F0F1F5' : '#5D667A'"
      sticky
    >
      <van-tab title="全部"
        ><orderAll @changeTheme="changeTheme" :theme="theme"></orderAll
      ></van-tab>
      <van-tab title="待付款"
        ><obligation @changeTheme="changeTheme" :theme="theme"></obligation
      ></van-tab>
      <van-tab title="已完成"
        ><kateKao @changeTheme="changeTheme" :theme="theme"></kateKao
      ></van-tab>
      <van-tab title="已取消"
        ><cancelOrder @changeTheme="changeTheme" :theme="theme"></cancelOrder
      ></van-tab>
    </van-tabs>
  </div>
</template>

<script>
import orderAll from "@/components/order/orderAll";
import obligation from "@/components/order/obligation";
import kateKao from "@/components/order/kateKao";
import cancelOrder from "@/components/order/cancelOrder";
import { Tab, Tabs, Toast, List } from "vant";
export default {
  components: {
    [Toast.name]: Toast,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    orderAll,
    obligation,
    kateKao,
    cancelOrder,
  },
  data() {
    return {
      active: 0,
      theme: 1,
    };
  },

  created() {
    if (sessionStorage.getItem("theme") == 2) {
      this.theme = 2;
    } else {
      this.theme = 1;
    }
  },
  methods: {
    changeTheme(theme) {
      this.theme = theme;
    },
  },
};
</script>

<style lang="less" scoped>
// /deep/.van-tabs__nav {
//   width: 70%;
//   padding-right: 30%;
// }
/deep/.van-tab {
  font-size: 0.32rem;
}
/deep/.van-tabs__line {
  width: 0.3rem !important;
  height: 0.06rem !important;
  border-radius: 0 !important;
}
.bgffffff {
  background: #f4f5f7;
  /deep/.van-tabs__nav {
    background-color: #fff;
  }
  /deep/.van-pull-refresh {
    // background-color: #fff;
  }
}

.black {
  background: #000;
  /deep/.van-tabs__nav {
    background-color: #12161f;
  }
  /deep/.van-pull-refresh {
    background-color: #000;
  }
}
</style>